import RequestAbstract from "../abstract";

export default class Merchants extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchants";
    }
}
